import React from 'react';
import PropTypes from 'prop-types';

const IconAssetWarning = ({ width = 16, height = 16, viewBox = '0 0 16 16' }) => {
    return <svg width={width} height={height} viewBox={viewBox} fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M4.01 4.72L10.32 11.06L8.16 13.22C7.41336 13.9639 6.4279 14.42 5.37762 14.5078C4.32734 14.5956 3.27981 14.3095 2.42 13.7L1.06 15.06L0 14L1.36 12.64C0.750476 11.7802 0.464367 10.7327 0.552195 9.68238C0.640023 8.6321 1.09614 7.64664 1.84 6.9L4.01 4.72ZM14 0L15.06 1.06L13.7 2.42C14.3095 3.27981 14.5956 4.32734 14.5078 5.37762C14.42 6.4279 13.9639 7.41336 13.22 8.16L11.22 10.16L4.9 3.84L6.9 1.84C7.64664 1.09614 8.6321 0.640023 9.68238 0.552195C10.7327 0.464367 11.7802 0.750476 12.64 1.36L14 0Z' fill='#FFA200' />
    </svg>;
};

IconAssetWarning.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string,
};

export default IconAssetWarning;
